import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import { getTasks } from 'actions/asyncActions';
import ListTable from 'components/common/ListTable';
import Date from 'components/common/cards/Date';
import TextEditorView from 'components/common/cards/TextEditorView';
import TasksFilter, { defaultCommonTasksFilter } from 'filters/TasksFilter';

export default class CommonTasks extends Component {
    columns = [
        {
            title: 'Задача',
            dataIndex: 'text',
            key: 'text',
            render: (text, { id }) =>
                <Link className='task-table-text' to={`/task/${id}`}>
                    <TextEditorView content={text} />
                </Link>
        }, {
            title: 'Сеть',
            dataIndex: ['_embedded', 'network', 'name'],
            key: 'network'
        }, {
            title: 'Регион',
            dataIndex: ['_embedded', 'region', 'name'],
            key: 'region'
        }, {
            title: 'Город',
            dataIndex: ['_embedded', 'city', 'name'],
            key: 'city'
        }, {
            title: 'Результаты',
            dataIndex: 'results',
            key: 'results'
        }, {
            title: 'Дата начала',
            dataIndex: 'startDate',
            key: 'startDate',
            render: date => <Date date={date} />
        }, {
            title: 'Выполнить до',
            dataIndex: 'endDate',
            key: 'endDate',
            render: date => <Date date={date} />
        }
    ];

    render() {
        return (
            <div>
                <ListTable
                    tableColumns={this.columns}
                    action={getTasks}
                    filterForm={TasksFilter}
                    initialFilters={defaultCommonTasksFilter}
                    rowClassName={({ priority }) => priority} />
            </div>
        );
    }
}
